import React, { useRef } from 'react';
import { Button } from 'reactstrap';
import { ModalWindow } from '../../modal/ModalWindow';
import { ApiEndpoints } from '../../../api/apiEndpoints';

export function IllustrationDeleteModal({ deleteAssetId, setDeleteAssetId, fetchAssets }) {
    const modalRef = useRef(null);

    const handleDelete = async () => {
        await fetch(`${ApiEndpoints.ManageIllustrations}/${deleteAssetId}`, {
            method: 'DELETE',
        });
        fetchAssets();
        modalRef.current.closeWindow();
    };

    return (
        <ModalWindow
            ref={modalRef}
            title="Delete Illustration"
            onClose={() => setDeleteAssetId(null)}
        >
            <p>Are you sure you want to delete this illustration? This action cannot be undone.</p>
            <div className="d-flex justify-content-end">
                <Button color="secondary" className="me-2" onClick={() => modalRef.current.closeWindow()}>
                    Cancel
                </Button>
                <Button color="danger" onClick={handleDelete}>
                    Delete
                </Button>
            </div>
        </ModalWindow>
    );
}
